import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BimestreProfileInfo from './BimestreProfileInfo';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '100%',
    },
});

export default function BimestreProfileWithoutChange({ bimestre }) {
    const classes = useStyles();


    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <BimestreProfileInfo bimestre={bimestre} />

            </CardContent>
        </Card>
    );
}